module.exports = __webpack_public_path__ + "assets/f845428960a3920c18c6af4d1e09b3fa.png";